import { BaseUseCase } from "@domains/useCases/UseCaseBase";
export default class EmailReport extends BaseUseCase {
    constructor(downloadRepo) {
        super();
        this.downloadRepo = downloadRepo;
    }
    fetchResult(data) {
        return this.downloadRepo.emailReport(data);
    }
}
